import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getCardIcon, getCardIconType, getCardTitle } from "./mockData";
import CalendarLoader from "../../common-components/CalendarLoader";
import { convertThenFormat } from "../../common-data/Converts";

const SummaryStatsCards = () => {
  const {
    hygieneCommandCenterStats,
    hygieneCommandCenterStatsLoading,
    hygieneCommandCenterStatsError,
  } = useSelector((state) => state.hygiene);

  const [statsData, setStatsData] = useState({});

  const EXCLUDED_KEYS = [
    "completed_percent",
    "pending_percent",
    "missed_percent",
    "date",
    "last_updated",
  ];

  useEffect(() => {
    if (
      !hygieneCommandCenterStatsLoading &&
      !hygieneCommandCenterStatsError &&
      hygieneCommandCenterStats?.status
    ) {
      setStatsData(hygieneCommandCenterStats?.data);
    } else {
      setStatsData({});
    }
  }, [
    hygieneCommandCenterStatsLoading,
    hygieneCommandCenterStatsError,
    hygieneCommandCenterStats,
  ]);

  return (
    <div className="mr-kpi-grid grid-4 mt15">
      {hygieneCommandCenterStatsLoading ? (
        <CalendarLoader daysCount={4} shiftsPerDay={2} />
      ) : (
        statsData &&
        Object.entries(statsData)?.map(([key, value]) => {
          return (
            <React.Fragment key={key}>
              {!EXCLUDED_KEYS.includes(key) && (
                <div className="mr-kpi-card">
                  <div className="hcc-ssc-kpi-card-header-container">
                    <div className="mr-kpi-head">
                      <div>
                        <p className="mr-kpi-title">{getCardTitle(key)}</p>
                        <div className="mr-kpi-value-row">
                          <div className="mr-kpi-value">{convertThenFormat(value || 0)}</div>
                        </div>
                        {/* {data?.assigned_percentage && (
                          <div className="mr-kpi-subtitle">
                            {data.assigned_percentage}
                          </div>
                        )} */}
                      </div>
                      <span
                        className={`mr-kpi-icon mr-kpi-icon--${getCardIconType(
                          key
                        )}`}
                      >
                        {getCardIcon(key)}
                      </span>
                    </div>

                    {/* {statsData[`${key}_percent`] !== undefined && (
                      <div className="hcc-ssc-progress-container">
                        <span className="hcc-ssc-progress-label">
                          {statsData[`${key}_percent`] === null ||
                          statsData[`${key}_percent`] === undefined ||
                          isNaN(statsData[`${key}_percent`])
                            ? "0%"
                            : `${Number(statsData[`${key}_percent`]).toFixed(
                                1
                              )}%`}
                        </span>
                        <div className="hcc-ssc-progress-bar">
                          <div
                            className={`hcc-ssc-progress-fill hcc-ssc-progress-fill--${getCardIconType(
                              key
                            )}`}
                            style={{
                              width: `${Math.min(
                                statsData[`${key}_percent`] === null ||
                                  statsData[`${key}_percent`] === undefined ||
                                  isNaN(statsData[`${key}_percent`])
                                  ? 0
                                  : Number(statsData[`${key}_percent`]),
                                100
                              )}%`,
                            }}
                          />
                        </div>
                      </div>
                    )} */}
                  </div>
                </div>
              )}
            </React.Fragment>
          );
        })
      )}
    </div>
  );
};

export default SummaryStatsCards;
